import React, { ReactNode, useState } from 'react';
import { Link } from 'react-router-dom';
import { logoUrl, tenant } from '../../../config/tenant';
import { CloseIcon, MenuIcon } from './icons';

export const SITE_NAV = [
	{ id: 'plataforma', label: 'A Plataforma' },
	{ id: 'como-funciona', label: 'Como Funciona' },
	{ id: 'solucoes', label: 'Soluções' },
	{ id: 'contato', label: 'Contato' },
];

interface SiteHeaderProps {
	/**
	 * Quando informado, os links de navegação rolam dentro da própria página
	 * (home). Sem ele, apontam para as seções da home via `/#id`.
	 */
	scrollTo?: (id: string) => void;
	/** ação secundária (texto) à esquerda do CTA */
	secondary?: ReactNode;
	/** botão laranja à direita */
	cta: ReactNode;
}

/** Cabeçalho das páginas públicas (home, indicação). Estilos em HomeRoot (.cr-header). */
const SiteHeader: React.FC<SiteHeaderProps> = ({ scrollTo, secondary, cta }) => {
	const [menuOpen, setMenuOpen] = useState(false);

	const navLink = (id: string, label: string) => {
		if (scrollTo) {
			return (
				<a
					key={id}
					href={`#${id}`}
					onClick={(e) => {
						e.preventDefault();
						setMenuOpen(false);
						scrollTo(id);
					}}
				>
					{label}
				</a>
			);
		}
		return (
			<Link key={id} to={`/#${id}`} onClick={() => setMenuOpen(false)}>
				{label}
			</Link>
		);
	};

	const logo = <img src={logoUrl()} alt={tenant.appName} />;

	return (
		<header className='cr-header'>
			<div className='cr-container cr-header__in'>
				{scrollTo ? (
					<a
						className='cr-logo'
						href='#inicio'
						onClick={(e) => {
							e.preventDefault();
							scrollTo('inicio');
						}}
						aria-label={`${tenant.appName} — início`}
					>
						{logo}
					</a>
				) : (
					<Link className='cr-logo' to='/' aria-label={`${tenant.appName} — início`}>
						{logo}
					</Link>
				)}
				<nav id='cr-nav' className={`cr-nav${menuOpen ? ' is-open' : ''}`} aria-label='Navegação principal'>
					{SITE_NAV.map((item) => navLink(item.id, item.label))}
				</nav>
				<div className='cr-header__actions'>
					{secondary}
					{cta}
					<button
						type='button'
						className='cr-menu-btn'
						onClick={() => setMenuOpen((v) => !v)}
						aria-label={menuOpen ? 'Fechar menu' : 'Abrir menu'}
						aria-expanded={menuOpen}
						aria-controls='cr-nav'
					>
						{menuOpen ? <CloseIcon size={22} /> : <MenuIcon />}
					</button>
				</div>
			</div>
		</header>
	);
};

export default SiteHeader;
